import { useState } from 'react';
import { ActionIcon, Tooltip, Group } from '@mantine/core';
import { IconManual, IconBlueprint, IconDial, IconBrokenBit } from './icons/CncIcons';
import { useNavigate } from 'react-router-dom';
import UserSettingsModal from './modals/UserSettingsModal';
import DebugModal from './modals/DebugModal';

export default function TopRightMenu() {
  const navigate = useNavigate();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [debugOpen, setDebugOpen] = useState(false);

  return (
    <>
      <Group gap={4}>
        <Tooltip label="Lessons" position="bottom" withArrow openDelay={200}>
          <ActionIcon variant="subtle" color="gray" onClick={() => navigate('/user-guide')} aria-label="Lessons">
            <IconManual size={18} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Technical Docs" position="bottom" withArrow openDelay={200}>
          <ActionIcon variant="subtle" color="gray" onClick={() => navigate('/technical-docs')} aria-label="Technical Docs">
            <IconBlueprint size={18} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="User Settings" position="bottom" withArrow openDelay={200}>
          <ActionIcon variant="subtle" color="gray" onClick={() => setSettingsOpen(true)} aria-label="User Settings">
            <IconDial size={18} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Debug" position="bottom" withArrow openDelay={200}>
          <ActionIcon variant="subtle" color="gray" onClick={() => setDebugOpen(true)} aria-label="Debug">
            <IconBrokenBit size={18} />
          </ActionIcon>
        </Tooltip>
      </Group>
      {settingsOpen && <UserSettingsModal onClose={() => setSettingsOpen(false)} />}
      {debugOpen && <DebugModal onClose={() => setDebugOpen(false)} />}
    </>
  );
}
